module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mainpage"
  }, [_c('div', {
    staticClass: "seo"
  }, [_c('seo-title', {
    attrs: {
      "content": "Volkswagen Erhvervsklub - Din Volkswagen familie"
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen Erhvervsklub og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-keywords', {
    attrs: {
      "content": "VW, VW Erhvervscenter, VW Erhvervsbiler, VW Erhvervsklub, Volkswagen"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": "Volkswagen Erhvervsklub - Din Volkswagen familie"
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen Erhvervsklub og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-google-name', {
    attrs: {
      "content": "Volkswagen Erhvervsklub - Din Volkswagen familie"
    }
  }), _vm._v(" "), _c('seo-google-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen Erhvervsklub og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-google-image', {
    attrs: {
      "content": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('p', {
    staticClass: "custom-body"
  }, [_vm._v("\n            Vælg din foretrukne forhandler\n        ")]), _vm._v(" "), (!_vm.loaded) ? _c('div', {
    staticClass: "loader",
    staticStyle: {
      "margin": "10px 0 20px 0",
      "opacity": "0.75",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    staticStyle: {
      "font-size": "48px",
      "color": "#0099da"
    }
  }), _c('br'), _vm._v("\n            Finder din nærmeste forhandler\n        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list-group",
    class: {
      'location': _vm.located
    }
  }, _vm._l((_vm.activeStores), function(store) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-2"
    }, [_c('img', {
      attrs: {
        "src": "static/images/vw-logo.png"
      }
    }), _vm._v(" "), (store.distance !== '') ? _c('sup', [_vm._v(_vm._s(store.distance) + "km")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-10 col-md-10 col-sm-10 col-xs-10"
    }, [_vm._v("\n                        " + _vm._s(store.name) + "\n                        "), _c('span', [_vm._v("\n                            " + _vm._s(store.street)), _c('br'), _vm._v("\n                            " + _vm._s(store.city) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "chooser"
    }, [(store.active) ? _c('a', {
      attrs: {
        "href": store.link
      }
    }, [_c('span', [_vm._v("Vælg")])]) : _c('i', [_vm._v("Kommer"), _c('br'), _vm._v("snart")])]), _vm._v(" "), _vm._m(1, true, false)])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-6 col-sm-6"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "custom-header"
  }, [_c('span', [_vm._v("Volkswagen")]), _vm._v("\n            Erhvervsklub\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "closest"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Baseret på din lokation\n                        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94c7567a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/index.vue
// module id = 245
// module chunks = 1